import { parse, format } from 'date-fns'

const useFormatDate = () => {
  const parseDate = (dateStr: string) => {
    let parsedDate = parse(dateStr)
    if (parsedDate && !isNaN(parsedDate.getTime())) return parsedDate

    const cleaned = dateStr.replace('T', ' ').replace(/\./g, ':')
    parsedDate = parse(cleaned)
    if (parsedDate && !isNaN(parsedDate.getTime())) return parsedDate

    return null
  }

  const formatDate = (dateStr?: any) => {
    if (!dateStr) return '-'

    const parsedDate = parseDate(dateStr)
    if (!parsedDate) return '-'

    return format(parsedDate, 'DD.MM.YYYY')
  }

  const formatDateWithTime = (dateStr?: any) => {
    if (!dateStr) return '-'

    const parsedDate = parseDate(dateStr)
    if (!parsedDate) return '-'

    return format(parsedDate, 'DD.MM.YYYY HH:mm')
  }

  return { formatDate, formatDateWithTime }
}

export default useFormatDate
